export default __webpack_public_path__ + "static/media/web.4b95d55f.svg";